//router
import LayoutsRoute from "./router/layouts-route";
import { NotificationContainer } from "react-notifications";
// import  './assets/css/custom.css';

function App() {
    return (
        <>
            <LayoutsRoute />
            <NotificationContainer></NotificationContainer>
        </>
    );
}

export default App;
